declare global {
  interface Window {
    DocumentTouch: () => unknown;
  }
}

export function isTouchableDevice(): boolean {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        (window.DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof window.DocumentTouch))
    ) ||
    !!(
      typeof navigator !== 'undefined' &&
      (navigator.maxTouchPoints || 'msMaxTouchPoints' in navigator)
    )
  );
}

export function redirect(path: string): void {
  window.location.href = path;
}

export function getCurrentOrigin(): string {
  return window.location.origin;
}

export function getCurrentQuery(): string {
  return window.location.search;
}
